import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { ORDERS } from '../../../../navigation/constants'

export default function ResultPanel({ result }) {
    const { t } = useTranslation()
    const { warehouse_id } = useParams()
    if (!result) return null
    const successKey = result.status === 'created' ? 'result_success' : 'result_partial'
    const showPendingLink = result.status === 'created' || result.status === 'partial'
    return (
        <div className="mt-6 p-4 border border-green-200 bg-green-50 rounded text-sm">
            <p className="font-semibold">
                ✓ {t(`natura_operations.create_order.${successKey}`, { delivery_number: result.delivery_number })}
            </p>
            {result.preview?.customer && (
                <p className="mt-2">
                    {t('natura_operations.create_order.result_label_customer')}: <strong>{result.preview.customer.fullname}</strong>{' '}
                    — {result.preview.customer.city}/{result.preview.customer.province}
                </p>
            )}
            {result.preview?.items?.length > 0 && (
                <p className="mt-1">
                    {t('natura_operations.create_order.result_label_items')}: <strong>{result.preview.items.length}</strong>{' '}
                    | {t('natura_operations.create_order.result_label_shipping_method')}: <strong>{result.preview.shipping_method_id}</strong>
                </p>
            )}
            {result.warnings?.length > 0 && (
                <ul className="mt-2 list-disc pl-6 text-amber-700">
                    {result.warnings.map((w, i) => <li key={i}>⚠ {w}</li>)}
                </ul>
            )}
            {showPendingLink && warehouse_id && (
                <Link
                    to={ORDERS.replace(':warehouse_id', warehouse_id)}
                    className="inline-block mt-3 text-sm text-amber-700 hover:text-amber-800 underline"
                >
                    {t('natura_operations.create_order.view_pending')} →
                </Link>
            )}
        </div>
    )
}
